export default function ($translate) {
    return {
        KEYS: {
            NOT_STARTED: 'NOT_STARTED',
            IN_PROGRESS: 'IN_PROGRESS',
            IN_ASSESSMENT: 'IN_ASSESSMENT',
            PASSED: 'PASSED',
            NOT_PASSED: 'NOT_PASSED',
            CANCELLED: 'CANCELLED'
        },
        LABELS: {
            NOT_STARTED: $translate.instant('course.Not started'),
            IN_PROGRESS: $translate.instant('course.In progress'),
            IN_ASSESSMENT: $translate.instant('validations.In validation'),
            PASSED: $translate.instant('course.Passed'),
            NOT_PASSED: $translate.instant('course.Not passed'),
            CANCELLED: $translate.instant('course.Cancelled')
        }
    };
}



// WEBPACK FOOTER //
// ./src/app/enums/course/progressStatusType/index.js